import { useTheme } from "context/ThemeContext";
import { useCurrentUser } from "context/UserContext";
import { FiMenu, FiMoon, FiSun } from "react-icons/fi";

interface AdminTopBarProps {
  onToggleMobileSidebar: () => void;
}

const AdminTopBar = ({ onToggleMobileSidebar }: AdminTopBarProps) => {
  const { currentUser } = useCurrentUser();
  const { theme, toggleTheme } = useTheme();

  return (
    <header className="admin-topbar">
      <button
        className="admin-topbar__hamburger"
        onClick={onToggleMobileSidebar}
        aria-label="Toggle sidebar"
      >
        <FiMenu size={20} />
      </button>

      <div className="admin-topbar__spacer" />

      <input
        className="admin-topbar__search"
        type="text"
        placeholder="Search..."
        disabled
      />

      <select className="admin-topbar__store-filter" disabled>
        <option>All stores</option>
      </select>

      <button
        className="admin-topbar__theme-toggle"
        onClick={toggleTheme}
        aria-label={theme === "light" ? "Switch to dark mode" : "Switch to light mode"}
      >
        {theme === "light" ? <FiMoon size={18} /> : <FiSun size={18} />}
      </button>

      {currentUser?.photoURL && (
        <img
          src={currentUser.photoURL}
          alt={`${currentUser.displayName || "User"} profile`}
          className="admin-topbar__avatar"
        />
      )}
    </header>
  );
};

export default AdminTopBar;
